import { render, staticRenderFns } from "./zhulao-order.vue?vue&type=template&id=a13c13cc&scoped=true&"
import script from "./zhulao-order.vue?vue&type=script&lang=js&"
export * from "./zhulao-order.vue?vue&type=script&lang=js&"
import style0 from "./zhulao-order.vue?vue&type=style&index=0&id=a13c13cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13c13cc",
  null
  
)

export default component.exports